import { render, staticRenderFns } from "./Flatbed.vue?vue&type=template&id=f5075adc&scoped=true"
import script from "./Flatbed.vue?vue&type=script&lang=js"
export * from "./Flatbed.vue?vue&type=script&lang=js"
import style0 from "./Flatbed.vue?vue&type=style&index=0&id=f5075adc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5075adc",
  null
  
)

export default component.exports